exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dynamic-textarea{border-radius:3px;border:1px solid #dee2e6;color:#979797;min-height:100px}.dynamic-textarea.form-control-plaintext{border:0;border-bottom:1px solid #dee2e6;border-radius:0;padding:.375rem .75rem}.dynamic-textarea:focus{color:#000;background-color:#fff;border-color:#000;box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08fa69f3","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DynamicForms/Textarea.vue
// module id = 795
// module chunks = 3